import Head from 'next/head'
import Script from 'next/script'
import env from 'src/@legacy/utilities/env'
import HeaderEmployer from '../components/HeaderEmployer'
import CrispChatEmployer from '../utillities/CrispChatEmployer'
import { ResetStyle } from './reset.style'

const withLayoutEmployer = (Page?: any, className?: string, scrollToContactFormProps?: any, resetStyle?: boolean) => {
  const HOCCom = (props: any) => {
    return (
      <>
        {resetStyle && (
          <style jsx global>
            {ResetStyle}
          </style>
        )}
        <Head>
          <link rel="apple-touch-icon" href={`${env.PUBLIC_EMPLOYER_APP_DOMAIN}/img/apple-touch-icon.png`} />
          <link rel="shortcut icon" type="image/png" sizes="32x32" href="/favicon_32x32.png"></link>
          <link rel="shortcut icon" type="image/png" sizes="16x16" href="/favicon_16x16.png"></link>
          <link rel="preconnect" href="https://fonts.gstatic.com"></link>
          {/* <link
            href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,400&display=swap"
            rel="stylesheet"
            media="print"
            // eslint-disable-next-line react/no-unknown-property
            //@ts-ignore
            onLoad="this.media='all'"
          /> */}
          <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap" rel="stylesheet"></link>
        </Head>
        <div className={className || 'ant-layout company-layout'}>
          <HeaderEmployer scrollToContactFormProps={scrollToContactFormProps} />
          <div className="container">
            <Page {...props} />
          </div>
          {/* <Footer /> */}
        </div>
        {env.PUBLIC_GTM_KEY && (
          <Script
            id="gtm-script"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer', '${env.PUBLIC_GTM_KEY}');
            `
            }}
          />
        )}
        {env.PUBLIC_GTM_KEY && (
          <noscript>
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=${env.PUBLIC_GTM_KEY}`}
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}></iframe>
          </noscript>
        )}
        {env.PUBLIC_ENABLE_LIVE_CHAT === 'true' && <CrispChatEmployer />}
      </>
    )
  }

  HOCCom.getInitialProps = Page.getInitialProps
  HOCCom.getStaticProps = Page.getStaticProps
  return HOCCom
}

export default withLayoutEmployer
